import React from 'react';
import { fr } from 'date-fns/locale';
import { Calendar } from './ui/calendar';

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const fromIso = (s) => new Date(`${s}T12:00:00`);
const frDay = (s) => fromIso(s).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

export const BlockedDaysPanel = ({ blocked, onToggle }) => {
  const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' });
  const upcoming = blocked.filter((b) => b.date >= today);

  return (
    <div data-testid="admin-blocked-days" style={{ display: 'flex', gap: '56px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
      <div>
        <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '16px', maxWidth: '320px' }}>
          Cliquez sur un jour pour le bloquer ; cliquez à nouveau pour le libérer. Aucun rendez-vous ne sera proposé les jours bloqués.
        </p>
        <Calendar
          data-testid="admin-blocked-calendar"
          mode="multiple"
          locale={fr}
          weekStartsOn={1}
          selected={blocked.map((b) => fromIso(b.date))}
          onDayClick={(day) => onToggle(toIso(day))}
          disabled={(d) => toIso(d) < today || d.getDay() === 0 || d.getDay() === 6}
          className="rounded-md border"
        />
      </div>
      <div style={{ minWidth: '260px' }}>
        <p className="meta-text" style={{ color: 'var(--text-light)', marginBottom: '16px' }}>Jours bloqués à venir</p>
        {upcoming.length === 0 && <p data-testid="admin-blocked-empty" className="body-regular">Aucun jour bloqué.</p>}
        {upcoming.map((b) => (
          <div key={b.date} data-testid={`admin-blocked-${b.date}`} style={{ display: 'flex', justifyContent: 'space-between', gap: '24px', padding: '10px 0', borderBottom: '1px solid var(--border-light)' }}>
            <span className="body-regular" style={{ textTransform: 'capitalize' }}>{frDay(b.date)}</span>
            <button data-testid={`admin-unblock-${b.date}`} onClick={() => onToggle(b.date)} className="body-small" style={{ background: 'none', border: 'none', color: '#9b2c2c', cursor: 'pointer' }}>Libérer</button>
          </div>
        ))}
      </div>
    </div>
  );
};
